/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/providers/apiService/api.service';
import * as moment from 'moment';
import { NavigationExtras, Router } from '@angular/router';
import { NavController, AlertController } from '@ionic/angular';
import { ToastService } from 'src/app/providers/toastService/toast.service';
import { AccessService } from 'src/app/providers/access/access.service';
@Component({
  selector: 'app-notification',
  templateUrl: './notification.page.html',
  styleUrls: ['./notification.page.scss'],
})
export class NotificationPage implements OnInit {
  user: any;
  unreadCount: any;
  unreadNotifications: any[]= [];
  readNotifications: any[]= [];
  timestamp: any;
  pageRead: number;
  pageUnread: number;
  perPage: number;
  hasMoreRead: boolean;
  hasMoreUnread: boolean;
  hasReadSkelton: boolean;
  hasUnreadSkelton: boolean;
  readCount: any;
  constructor(
    private apiService: ApiService,
    public router: Router,
    public navCtrl: NavController,
    public toastService: ToastService, 
    private alertController: AlertController,
    public accessService: AccessService,
  ) {
    this.pageRead = 1;
    this.pageUnread = 1;
    this.perPage = 10;
    this.hasMoreRead = true;
    this.hasMoreUnread = true;
  }

  ngOnInit() {
    this.getunreadNotificationCount();
    this.getReadNotificationCount();}
  ionViewWillEnter() {
    this.getunreadNotificationCount();
    this.getReadNotificationCount();
    this.getReadNotifications();
    this.getUnreadNotifications();
  }
  ionViewDidEnter() {
    this.accessService.resetLogoutTimer();
  }
  
  getReadNotifications() {
    this.readNotifications=[];
    this.hasReadSkelton = true;
    const params = {
      page: this.pageRead,
      perPage: this.perPage
    };
    this.apiService.post('user/get-readnotifications', params).subscribe(
      (res) => {
        this.hasReadSkelton = false;
        if (res.error === false) {
          // eslint-disable-next-line max-len
          res.data.notifications.map(
            (element) =>{
              element.UserNotification.timeAgo = moment(
              element.UserNotification.created_at
              ).fromNow();
              this.readNotifications.push(element);
            });
            setTimeout(() => {
              if (this.readNotifications.length >= this.readCount) {
                this.hasMoreRead = false;
              } else {
                this.pageRead++;
              }
            }, 50);
          }
      },
      (err) => {
        this.hasReadSkelton = false;
      }
    );
  }

  getUnreadNotifications() {
    this.unreadNotifications=[];
    this.hasUnreadSkelton = true;
    const params = {
      page: this.pageUnread,
      perPage: this.perPage
    };
    this.apiService.post('user/get-unreadnotifications', params).subscribe(
      (res) => {
        this.hasReadSkelton = false;
        if (res.error === false) {
          //console.log(res.data);
          // eslint-disable-next-line max-len
          res.data.notifications.map(
            (element) =>{
              element.UserNotification.timeAgo = moment(
              element.UserNotification.created_at
              ).fromNow();
              this.unreadNotifications.push(element);
            });
            setTimeout(() => {
              if (this.unreadNotifications.length >= this.unreadCount) {
                this.hasMoreUnread = false;
              } else {
                this.pageUnread++;
              }
            }, 50);
          }
      },
      (err) => {
        this.hasUnreadSkelton = false;
      }
    );
  }

  notificationDetail(notification) {
  this.readNotification(notification.UserNotification.id);
    this.pageRead = 1;
    this.pageUnread = 1;
    switch (notification.UserNotification.notification_action) {
      case '101':
          this.navCtrl.navigateForward('/submissionInfo', {
            queryParams: {
              id: notification.UserNotification.parent_object_id,
            },
          });      
          break;
      case '103':

      //console.log('103', notification);
        this.navCtrl.navigateForward('/submissionInfo', {
          queryParams: {
            id: notification.UserNotification.parent_object_id,
          },
        });
        break;
      default:
        this.navCtrl.navigateForward('/notificationDetails', {
          state: notification,
        });
    }
  }

  readNotification(notificationID) {
    const params = {};
    
    this.apiService.post('user/read-notification/'+notificationID,params).subscribe(
      (res) => {
        if (res.error === false) {
        }
      },
      (err) => {
        //console.log(err);
      }
    );
    
  }

  doInfiniteUnread(infiniteScroll) {
    this.hasUnreadSkelton = true;
    if (this.hasMoreUnread) {
      const params = {
        page: this.pageUnread,
        perPage: this.perPage
      };
      this.apiService.post('user/get-unreadnotifications', params).subscribe(
        (res) => {
          this.hasUnreadSkelton = false;
          if (res.error === false) {
            // eslint-disable-next-line max-len
            res.data.notifications.map(
              (element) =>{
                element.UserNotification.timeAgo = moment(
                element.UserNotification.created_at
                ).fromNow();
                this.unreadNotifications.push(element);
                
              });
              infiniteScroll.target.complete();
              setTimeout(() => {
                if (this.unreadNotifications.length >= this.unreadCount) {
                  this.hasMoreUnread = false;
                } else {
                  this.pageUnread++;
                }
              }, 50);
            }
        },
          async (err) => {
          this.hasUnreadSkelton = false;
          infiniteScroll.target.complete();
        }
      );
    } else {
      this.hasUnreadSkelton = false;
      infiniteScroll.target.complete();
      infiniteScroll.target.disabled = true;
    }
  }
  doInfiniteRead(infiniteScroll) {
    this.hasReadSkelton = true;
    if (this.hasMoreRead) {
      const params = {
        page: this.pageRead,
        perPage: this.perPage
      };
      this.apiService.post('user/get-readnotifications', params).subscribe(
        (res) => {
          this.hasReadSkelton = false;
          if (res.error === false) {
            // eslint-disable-next-line max-len
            res.data.notifications.map(
              (element) =>{
                element.UserNotification.timeAgo = moment(
                element.UserNotification.created_at
                ).fromNow();
                this.readNotifications.push(element);
                
              });
              infiniteScroll.target.complete();
              setTimeout(() => {
                if (this.readNotifications.length >= this.readCount) {
                  this.hasMoreRead = false;
                } else {
                  this.pageRead++;
                }
              }, 50);
            }
        },
          async (err) => {
            //console.log('error');
            //console.log(err);
          this.hasReadSkelton = false;
          infiniteScroll.target.complete();
        }
      );
    } else {
      this.hasReadSkelton = false;
      infiniteScroll.target.complete();
      infiniteScroll.target.disabled = true;
    }
  }


  async markallasread() {

    const alert = await this.alertController.create({
      header: 'Mark all as read?',
      cssClass: 'markasread',
      message: 'Note: all notifications will still be visible, but the "new" icon will disappear and the unread notification count will be reset.  This will affect all notifications, including reasons for submissions returned for action.',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
          },
        },
        {
          text: 'OK',
          role: 'confirm',
          handler: () => {
          },
        },
      ],
    });

    await alert.present();
    const { role } = await alert.onDidDismiss();
    if (role == "confirm")
    {
      this.readNotification('all');  
      this.toastService.presentToast('success', 'Successfully marked all as read');
      this.getUnreadNotifications();
      this.getReadNotifications();
    }

  }

  getunreadNotificationCount() {
    this.apiService
      .post('user/get-unread-notification-count', {})
      .subscribe(
        (res) => {
          if (res.error === false) {
            this.unreadCount = res.data.unread_notifications;
          }
        },
        (err) => {
          //console.log(err);
        }
      );
  }
  getReadNotificationCount() {
    this.apiService
      .post('user/get-read-notification-count', {})
      .subscribe(
        (res) => {
          if (res.error === false) {
            this.readCount = res.data.read_notifications;
          }
        },
        (err) => {
          //console.log(err);
        }
      );
  }
}
